module.exports = __webpack_public_path__ + "static/game-off.e5542868.svg";


//////////////////
// WEBPACK FOOTER
// ./src/components/simple/ScreenButton/game-off.svg
// module id = 333
// module chunks = 168707334958949